import { render, staticRenderFns } from "./QuizWidget.vue?vue&type=template&id=455db11c&scoped=true"
import script from "./QuizWidget.vue?vue&type=script&lang=js"
export * from "./QuizWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "455db11c",
  null
  
)

export default component.exports